import { MagnifyingGlassIcon } from '@radix-ui/react-icons'
import { TextField } from '@radix-ui/themes'
import React from 'react'
import styled from 'styled-components'

const StyledTextFieldRoot = styled(TextField.Root)`
  min-height: 2rem;
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  border-radius: 4px;
  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton} !important;
  }

  &:focus-within {
    border: 1px solid ${({ theme }) => theme.forecast.activeText};
  }

  input::selection {
    background: ${({ theme }) => theme.forecast.primary}66;
    color: ${({ theme }) => theme.forecast.defaultText};
  }
`

const StyledTextFieldSlot = styled(TextField.Slot)`
  padding: 4px;
`

function formatResultCountMessage(
  query: string,
  resultCount?: number
): string | undefined {
  if (!query.trim() || resultCount === undefined) {
    return undefined
  }

  if (resultCount === 0) {
    return 'No results'
  }

  if (resultCount === 1) {
    return '1 result'
  }

  return `${resultCount} results`
}

interface SearchBarProps {
  value: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  style?: React.CSSProperties
  className?: string
  onKeyDown?: (e: React.KeyboardEvent) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  disabled?: boolean
  resultCount?: number
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search',
  style,
  className,
  onKeyDown,
  onFocus,
  disabled,
  resultCount,
}) => {
  const statusMessage = formatResultCountMessage(value, resultCount)

  return (
    <StyledTextFieldRoot
      placeholder={placeholder}
      variant='soft'
      value={value}
      className={className}
      style={style}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      disabled={disabled}
      aria-label={statusMessage}>
      <StyledTextFieldSlot>
        <MagnifyingGlassIcon height='16' width='16' />
      </StyledTextFieldSlot>
    </StyledTextFieldRoot>
  )
}

export default SearchBar
